<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-col :lg="8">
          {{ $t("cadastro-usuarios") }}
          <small>({{ total }} registros)</small>
        </el-col>
        <el-col :offset="8" :lg="8">
          <el-pagination
            class="right"
            :page-size="records"
            background
            @current-change="fetchRecords"
            @size-change="changeSize"
            :current-page.sync="filter.page"
            layout="sizes, prev, pager, next"
            :page-sizes="[
              50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
            ]"
            :total="total"
          ></el-pagination>
        </el-col>
      </div>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input
            :placeholder="$t('pesquisar')"
            prefix-icon="el-icon-search"
            v-model="filter.word"
            v-on:keyup.native.enter="fetchRecords()" 
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="fetchRecords"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t("adicionar") }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="customer"
          :label="$t('cliente')"
          :filters="filterColumn('customer')"
          :filter-method="filterHandler"
        ></el-table-column>
        <el-table-column
          sortable
          prop="name"
          :label="$t('nome')"
        ></el-table-column>
        <el-table-column prop="type" :label="$t('tipo')" sortable>
          <template slot-scope="scope">{{
            scope.row.type === "1"
              ? $t("interno")
              : scope.row.type === "2"
              ? $t("cliente")
              : scope.row.type === "3"
              ? $t("parceiro")
              : scope.row.type === "4"
              ? $t("motorista")
              : $t("filial")
          }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="username"
          :label="$t('login')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="mail"
          :label="$t('email')"
        ></el-table-column>
        <el-table-column prop="active" :label="$t('ativo')" sortable>
          <template slot-scope="scope">{{
            scope.row.active ? $t("sim") : $t("nao")
          }}</template>
        </el-table-column>
        <el-table-column width="240">
          <template slot-scope="scope">
            <el-button
              v-if="impersonable(scope.row)"
              type="warning"
              size="mini"
              icon="el-icon-right"
              @click="impersonate(scope.row)"
              >Entrar</el-button
            >
            <el-button
              type="info"
              icon="el-icon-edit"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { UserService } from "@/services/users/user.services";

// ENTRAR: cliente, licenciado e filial (motorista e interno ficam de fora).
const IMPERSONABLE_TYPES = ["2", "3", "5"];

export default {
  name: "User",
  methods: {
    impersonable(row) {
      return this.canImpersonate && row.active && IMPERSONABLE_TYPES.includes(row.type);
    },
    impersonate(row) {
      // Abre a aba antes da chamada: depois do await o navegador bloqueia como pop-up.
      const tab = window.open("", "_blank");
      if (!tab) {
        return this.$message({ type: "error", message: "Permita pop-ups deste site para usar o Entrar." });
      }
      UserService.impersonate(row.id)
        .then((token) => {
          tab.location.href = `/entrar-como#${token}`;
        })
        .catch((error) => {
          tab.close();
          this.$message({ type: "error", message: error });
        });
    },

    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetchRecords();
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      UserService.list(vm.records, vm.filter.page, vm.filter.word)
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.replace({ name: "user.add" });
    },
    editar: function (id) {
      this.$router.replace({
        name: "user.edit",
        params: { id: id },
      });
    },
    filterColumn(column) {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        if (!list.find((x) => x.value === row[column])) {
          list.push({
            text: row[column],
            value: row[column],
          });
        }
      }
      list.sort(function (a, b) {
        if (a.text > b.text) return 1;
        if (a.text < b.text) return -1;
        return 0;
      });
      return list;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-usuario", { user: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        UserService.delete(id)
          .then((response) => {
            setTimeout(() => {
              const index = vm.tableData.findIndex((dt) => dt.id == id);
              vm.tableData.splice(index, 1);
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("usuario-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
    UserService.impersonationAllowed()
      .then((allowed) => (vm.canImpersonate = allowed))
      .catch(() => {});
  },
  data() {
    return {
      records: 50,
      filter: {
        page: 1,
        word: "",
      },
      total: 0,
      tableData: [],
      canImpersonate: false,
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>
